import(/* webpackMode: "eager", webpackExports: ["AnalyticsUserProvider"] */ "/workspace/apps/web/src/core/providers/analytics-user.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthenticationProvider"] */ "/workspace/apps/web/src/core/providers/authentication.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BottomNavigationVisibilityProviderWrapper"] */ "/workspace/apps/web/src/core/providers/bottom-navigation-visibility.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OverlayRootProvider"] */ "/workspace/apps/web/src/core/providers/dialog-store.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NativeBridgeStoreProvider","webBridge"] */ "/workspace/apps/web/src/core/providers/native-bridge-store.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useOnetalkWidgetStatus","useOpenOnetalkWidget","usePrepareOnetalkWidget"] */ "/workspace/apps/web/src/core/providers/onetalk-widget.context.ts");
;
import(/* webpackMode: "eager", webpackExports: ["OnetalkWidgetProvider"] */ "/workspace/apps/web/src/core/providers/onetalk-widget.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScriptProvider"] */ "/workspace/apps/web/src/core/providers/script.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TanstackQueryClientProvider"] */ "/workspace/apps/web/src/core/providers/tanstack-query-client.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TelemetryUserProvider"] */ "/workspace/apps/web/src/core/providers/telemetry-user.provider.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/entities/authentication/hooks/use-authorization.ts");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/entities/authentication/model/authorization.context.ts");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/entities/lesson/lib/view-models/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LessonCardHeader"] */ "/workspace/apps/web/src/entities/lesson/ui/lesson-card-header/lesson-card-header.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/entities/lesson/ui/lesson-quiz/blank-filling-hint-funnel.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/entities/lesson/ui/lesson-quiz/blank-filling-quiz-funnel.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/entities/lesson/ui/lesson-quiz/multi-choice-sentence-hint-funnel.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/entities/lesson/ui/lesson-quiz/multi-choice-sentence-quiz-funnel.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/entities/lesson/ui/lesson-quiz/multi-choice-word-hint-funnel.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/entities/lesson/ui/lesson-quiz/multi-choice-word-quiz-funnel.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/entities/lesson/ui/lesson-quiz/pronounce-ruby.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/entities/lesson/ui/lesson-quiz/sentence-making-hint-funnel.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/entities/lesson/ui/lesson-quiz/sentence-making-quiz-funnel.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/entities/lesson/ui/lesson-quiz/wrong-blank-filling.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/entities/lesson/ui/lesson-quiz/wrong-multi-choice-sentence.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/entities/lesson/ui/lesson-quiz/wrong-multi-choice-word.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/entities/lesson/ui/lesson-quiz/wrong-sentence-making.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PreStudyProgress"] */ "/workspace/apps/web/src/entities/lesson/ui/pre-study-progress/pre-study-progress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrialLessonCardHeader"] */ "/workspace/apps/web/src/entities/lesson/ui/trial-lesson-card-header/trial-lesson-card-header.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/entities/subscribes/hooks/use-subscribe-error-static-model.ts");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/entities/subscribes/hooks/use-subscribe-ticket-destination.ts");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/entities/subscribes/hooks/use-trial-subscribe-static-model.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/apps/web/src/entities/subscribes/ui/product-type-card/product-type-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/apps/web/src/entities/subscribes/ui/promotion-badge/promotion-badge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/apps/web/src/entities/subscribes/ui/smart-talk-trial-ticket-card/smart-talk-trial-ticket-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubscribeDiscountBadge","SubscribeOriginalPrice"] */ "/workspace/apps/web/src/entities/subscribes/ui/subscribe-price-meta/subscribe-price-meta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/apps/web/src/entities/subscribes/ui/subscribe-summary-section/subscribe-summary-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/apps/web/src/entities/subscribes/ui/subscribe-ticket-card/subscribe-ticket-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/apps/web/src/entities/subscribes/ui/subscribe-ticket-period-chip/subscribe-ticket-period-chip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppOpenButton"] */ "/workspace/apps/web/src/features/native/ui/app-open-button.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/shared/config/i18n/client.ts");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/shared/config/i18n/provider.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/shared/config/i18n/user-locale-bootstrap.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/shared/models/native-bridge-store.model.ts");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/shared/ui/alert-dialog/alert-dialog.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/shared/ui/bottom-navigation/bottom-navigation.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/shared/ui/carousel/carousel.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/shared/ui/client-only-debugger/client-only-debugger.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/shared/ui/client-only/client-only.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/shared/ui/confirm-dialog/confirm-dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/apps/web/src/shared/ui/container/container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalLoading","GlobalLoadingBoundary"] */ "/workspace/apps/web/src/shared/ui/global-loading/global-loading.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/apps/web/src/shared/ui/grid/grid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/apps/web/src/shared/ui/modal/modal.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/shared/ui/notion-renderer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Overlay"] */ "/workspace/apps/web/src/shared/ui/overlay/overlay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/apps/web/src/shared/ui/safe-area-view/safe-area-view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/apps/web/src/shared/ui/section/section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toast","ToastAction","ToastClose","ToastDescription","Toaster","ToastProvider","ToastTitle","ToastViewport"] */ "/workspace/apps/web/src/shared/ui/toaster/toaster.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/shared/ui/top-navigation/spa-history-tracker.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/shared/ui/top-navigation/top-navigation.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/widgets/bottom-navigation-with-condition/bottom-navigation-visibility.context.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/widgets/bottom-navigation-with-condition/bottom-navigation-with-condition.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JpCollectionPopup"] */ "/workspace/apps/web/src/widgets/jp-collection/jp-collection.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/@next+third-parties@15.5.3_next@15.5.28_@babel+core@7.29.7_supports-color@8.1.1__@opent_2cc6741a09b6046693c663c643fa2d09/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/@next+third-parties@15.5.3_next@15.5.28_@babel+core@7.29.7_supports-color@8.1.1__@opent_2cc6741a09b6046693c663c643fa2d09/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/@next+third-parties@15.5.3_next@15.5.28_@babel+core@7.29.7_supports-color@8.1.1__@opent_2cc6741a09b6046693c663c643fa2d09/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["HydrationBoundary"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/HydrationBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/IsRestoringProvider.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/useIsFetching.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/useMutation.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating","useMutationState"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/useMutationState.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/useQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/useQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseInfiniteQuery"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/useSuspenseInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQueries"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/useSuspenseQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQuery"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/useSuspenseQuery.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/next@15.5.28_@babel+core@7.29.7_supports-color@8.1.1__@opentelemetry+api@1.9.1_@playwri_73ab67d97fa4fbe752b27c5cdbe50af3/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/AiPodoIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/AnimPodoPrestudyDialogIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/BottomNavigationAiLearningIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/BottomNavigationHomeIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/BottomNavigationLessonIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/BottomNavigationMypodoIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/BottomNavigationReservationIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/BottomNavigationTutorIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/BusinessMainIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/CheerupIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/EmptyLessonIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/LevelUpIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/LoadingIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/LowSegmentIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/MiddleSegmentIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/NotificationIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/PartyPodoIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/RelaxingPodoIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/SuccessIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/SurfingPodoIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/TicketEnjaIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/TopSegmentIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/WalkingIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/WrongIconLottie.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/alert-dialog/alert-dialog-v1.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/alert-dialog/alert-dialog.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/bottom-sheet/bottom-sheet.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/design-system-temp/src/components/button/button-v1.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/button/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/design-system-temp/src/components/checkbox/checkbox-v1.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/checkbox/checkbox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/design-system-temp/src/components/chip/chip-v3.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/design-system-temp/src/components/chip/chip-with-badge-v3.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/design-system-temp/src/components/chip/chip-with-badge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/design-system-temp/src/components/chip/chip.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/confirm-dialog/confirm-dialog-v1.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/confirm-dialog/confirm-dialog.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/feedback-list/feedback-list.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/popover/popover.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/progress/progress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/design-system-temp/src/components/radio/radio.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/separator/separator.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/stepper/stepper.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/tabs/tabs-v1.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/tabs/tabs.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/toaster/toaster.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/toggle/switch.tsx");
